import { Card,Divider,Stack,Typography } from '@mui/material';
import React from 'react';
import { aprovadoresModel } from '../../../types/reports/types';
import ImagesCmp from '../../ImagesCmp';

export default function ListaAprovadores({ listaAprovadores }: { listaAprovadores?: aprovadoresModel[] }) {

  return (
    <Card sx={{ width: '100%' }}>
      <Stack direction='row' alignItems='flex-start' spacing={1.5}>
        {listaAprovadores?.some((ele) => ele.status === 'aprovado') && <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='50%' spacing={1} padding={2}>
          <Typography color='textDisabled' fontWeight={600} variant='subtitle1' fontSize={15}>Aprovado</Typography>
          {listaAprovadores?.filter((ele) => ele.status === 'aprovado')?.sort((a, b) => { return a.dataAvaliacao > b.dataAvaliacao ? 1 : - 1; })?.map((aprov) => (
            <React.Fragment key={aprov.dataAvaliacao}>
              <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component={'p'}>
                Aprovado por:
                <Typography variant='subtitle2' fontSize={13} component={'span'}> {aprov?.nome}</Typography>
              </Typography>
              <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                Aprovado em:
                <Typography variant='subtitle2' fontSize={13} component='span'> {new Date(aprov?.dataAvaliacao)?.toLocaleString('pt-BR')}</Typography>
              </Typography>
              {aprov.comentario && <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                Comentário:
                <Typography variant='subtitle2' fontSize={13} component='span' sx={{ wordBreak: 'break-word' }}> {aprov.comentario}</Typography>
              </Typography>}
              {aprov.arquivo && (
                <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                  <ImagesCmp images={[aprov.arquivo]}/>
                </Typography>
              )}
              <Divider variant='middle' orientation='horizontal' flexItem />
            </React.Fragment>
          ))}
        </Stack>}
        {listaAprovadores?.some((ele) => ele.status === 'reprovado') && <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' width='50%' spacing={1} padding={2}>
          <Typography color='textDisabled' fontWeight={600} variant='subtitle1' fontSize={15}>Reprovado</Typography>
          {listaAprovadores?.filter((ele) => ele.status === 'reprovado')?.sort((a, b) => { return a.dataAvaliacao > b.dataAvaliacao ? 1 : - 1; })?.map((aprov) => (
            <React.Fragment key={aprov.dataAvaliacao}>
              <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component={'p'}>
                Reprovado por:
                <Typography variant='subtitle2' fontSize={13} component={'span'}> {aprov?.nome}</Typography>
              </Typography>
              <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                Reprovado em:
                <Typography variant='subtitle2' fontSize={13} component='span'> {new Date(aprov?.dataAvaliacao)?.toLocaleString('pt-BR')}</Typography>
              </Typography>
              {aprov.comentario && <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                Comentário:
                <Typography variant='subtitle2' fontSize={13} component='span' sx={{ wordBreak: 'break-word' }}> {aprov.comentario}</Typography>
              </Typography>}
              {aprov.arquivo && (
                <Typography fontWeight={600} variant='subtitle2' color='textDisabled' fontSize={13} component='p'>
                  <ImagesCmp images={[aprov.arquivo]}/>
                </Typography>
              )}
              <Divider variant='middle' orientation='horizontal' flexItem />
            </React.Fragment>
          ))}
        </Stack>}
      </Stack>
    </Card>
  );
}
